import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getAllSubjectByAllCategory, deleteSubject } from "../../redux/apiRequest";
import { createAxios } from '../../createInstance';
import { loginSuccess } from '../../redux/authSlice';
import CreateNew from './CreateNew';
import CreateExam from './CreateExam';
import { showToast } from "../../Components/ToastMessage";

import styles from './Home.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.login?.currentUser);
    const axiosJWT = useMemo(() => createAxios(user, dispatch, loginSuccess), [user, dispatch]);

    const categoryState = useSelector((state) => state.categories.allcategory);
    const categories = useMemo(() => {
        if (!Array.isArray(categoryState?.listcategory)) return [];
        return categoryState.listcategory.map((category) => ({
            ...category,
            subjects: Array.isArray(category.subjects) ? category.subjects : [],
        }));
    }, [categoryState]);

    const [showPopup, setShowPopup] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [editingSubject, setEditingSubject] = useState(null);
    const [showPopupExam, setShowPopupExam] = useState(false);

    const handleSuccess = async () => {
        showToast({
            type: "success",
            title: "Thành công!",
            message: "Xóa chuyên đề thành công.",
            duration: 3000
        })
        getAllSubjectByAllCategory(user.accessToken, dispatch, axiosJWT);
    };

    const handleError = () => {
        showToast({
            type: "error",
            title: "Thất bại!",
            message: "Vui lòng thử lại sau.",
            duration: 3000
        })
    };

    const handleDeleteSubject = async (subject_id) => {
        await deleteSubject(
            subject_id,
            dispatch,
            user?.accessToken,
            axiosJWT,
            handleSuccess,
            handleError);
    }

    useEffect(() => {
        if (user?.accessToken) {
            getAllSubjectByAllCategory(user.accessToken, dispatch, axiosJWT);
        }
    }, [user?.accessToken, dispatch, axiosJWT]);

    const openCreateModal = useCallback((categoryId) => {
        setEditingSubject(null); // tạo mới
        setSelectedCategoryId(String(categoryId || ''));
        setShowPopup(true);
    }, []);

    const openEditSubjectModal = (subject, categoryId) => {
        setEditingSubject(subject); // sửa
        setSelectedCategoryId(String(categoryId || subject.category_id || ''));
        setShowPopup(true);
    };

    const closePopup = useCallback(() => {
        setShowPopup(false);
        setSelectedCategoryId('');
        setEditingSubject(null);
    }, []);

    const openExamModal = useCallback(() => setShowPopupExam(true), []);
    const closeExamModal = useCallback(() => setShowPopupExam(false), []);

    const handleNavigateSubject = useCallback((subjectId) => {
        navigate(`/chuyende/${subjectId}`);
    }, [navigate]);

    return (
        <div className={cx('home')}>
            <div className={cx('head')}>
                <div type="button" className={cx('head-button')} onClick={openExamModal}>
                    + Đề thi
                </div>
            </div>

            {categories.map((category) => (
                <div key={category.category_id} className={cx('category')}>
                    <div className={cx('category-header')}>
                        <div className={cx('category-actions')}>
                            <div
                                type="button"
                                className={cx('category-action', 'category-action--create')}
                                onClick={() => openCreateModal(category.category_id)}
                            >
                                Tạo mới
                            </div>
                        </div>
                        <div className={cx('category-name')}>{category.categoryName}</div>
                    </div>
                    <div className={cx('subject-list')}>
                        {category.subjects.map((subject) => (
                            <div
                                key={subject.subject_id}
                                className={cx('subject-card')}
                                onClick={() => handleNavigateSubject(subject.subject_id)}
                            >
                                <span className={cx('subject-name')}>{subject.subjectName}</span>
                                <div className={cx('subject-actions')}>
                                    <button
                                        type="button"
                                        className={cx('subject-action', 'subject-action--edit')}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            openEditSubjectModal(subject, category.category_id);
                                        }}
                                    >
                                        Sửa
                                    </button>
                                    <button
                                        type="button"
                                        className={cx('subject-action', 'subject-action--delete')}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleDeleteSubject(subject.subject_id)
                                        }}
                                    >
                                        Xóa
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))
            }

            {
                showPopup && (
                    <CreateNew
                        onClose={closePopup}
                        categoryId={selectedCategoryId}
                        editingSubject={editingSubject}
                        categories={categories}
                        getAllSubjectByAllCategory={getAllSubjectByAllCategory}
                        user={user}
                        axiosJWT={axiosJWT}
                    />
                )
            }

            {
                showPopupExam && (
                    <CreateExam
                        onClose={closeExamModal}
                        user={user}
                        axiosJWT={axiosJWT}
                    />
                )
            }
        </div >
    );
}

export default Home;
